
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CsSkuDialog extends Serenity.EntityDialog<CsSkuRow, any> {
        protected getFormKey() { return CsSkuForm.formKey; }
        protected getIdProperty() { return CsSkuRow.idProperty; }
        protected getLocalTextPrefix() { return CsSkuRow.localTextPrefix; }
        protected getNameProperty() { return CsSkuRow.nameProperty; }
        protected getService() { return CsSkuService.baseUrl; }
        protected getDeletePermission() { return CsSkuRow.deletePermission; }
        protected getInsertPermission() { return CsSkuRow.insertPermission; }
        protected getUpdatePermission() { return CsSkuRow.updatePermission; }

        protected form = new CsSkuForm(this.idPrefix);

        constructor() {
            super();

            this.form.VatType.element.parent();

            this.form.VatType.change(e => {
               var isVatTypeN =  this.VatTypeN;
               var isVatTypeV = this.VatTypeV;
               

               if (!isVatTypeN) {
                   Serenity.EditorUtils.setReadOnly(this.form.VatCode, !isVatTypeN);
                   return this.form.VatCode.value = "V0";
                  
               }
               else if (!isVatTypeV){
                Serenity.EditorUtils.setReadOnly(this.form.VatCode, isVatTypeV);
                return this.form.VatCode.value = "V7";
                
               }
            });

            this.form.StockFg.element.parent();
            this.form.StockFg.change(e => {
                var isStockFgT =  this.StockFgT;
                var isStockFgF = this.StockFgF;
                
 
                if (!isStockFgT) {
                    Serenity.EditorUtils.setReadOnly(this.form.StkUnit, isStockFgT);
                    Serenity.EditorUtils.setReadOnly(this.form.MinStockQty, isStockFgT);
                    Serenity.EditorUtils.setReadOnly(this.form.MaxStockQty, isStockFgT);
                    
                    return this.form.StkUnit.value = "";
                    return this.form.MinStockQty.value = 0;
                    return this.form.MaxStockQty.value = 0;
                    
                   
                }
                else if (!isStockFgF){
                    Serenity.EditorUtils.setReadOnly(this.form.StkUnit, !isStockFgF);
                    Serenity.EditorUtils.setReadOnly(this.form.MinStockQty, !isStockFgF);
                    Serenity.EditorUtils.setReadOnly(this.form.MaxStockQty, !isStockFgF);
                    
                 
                 
                }
             });
             this.form.ConsignFg.element.parent();
            this.form.ConsignFg.change(e => {
               var isConsignFgT =  this.ConsignFgT;
               var isConsignFgF = this.ConsignFgF;
               

               if (!isConsignFgT) {
                   Serenity.EditorUtils.setReadOnly(this.form.ConsignGp, isConsignFgT);
                   return this.form.ConsignGp.value = 0;
                  
               }
               else if (!isConsignFgF){
                Serenity.EditorUtils.setReadOnly(this.form.ConsignGp, !isConsignFgF);
                
                
               }
            });
        }

        
        private get VatTypeN() {
            return this.form.VatType.value != "N";
        }
        private get VatTypeV() {
            return this.form.VatType.value != "V";
        }
        private get StockFgT() {
            return this.form.StockFg.value != true;
        }
        private get StockFgF() {
            return this.form.StockFg.value != false;
        }
        private get ConsignFgT() {
            return this.form.ConsignFg.value != true;
        }
        private get ConsignFgF() {
            return this.form.ConsignFg.value != false;
        }

        protected updateInterface() {
            super.updateInterface();
            if (!this.isNew()) {
                if (this.entity.SkuCode) {
                    if (this.form.SkuCode.element.attr("readonly")) {
                        Serenity.EditorUtils.setReadonly(this.form.MarketDate.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.QtyOnhand.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.VatType.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.StockFg.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.ConsignFg.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.ConsignGp.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.StkUnit.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.PurUnitPrice.element, true);

                        //StockCostValue VatType
                    }
                    //Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                    //this.element.find('sup').hide();
                    //this.deleteButton.hide();
                   
                    
                }


            }
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();

            
            var Plucheck = Q.tryFirst(CsPluRow.getLookup().items, x=> x.SkuCode == this.entity.SkuCode);            
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
                
                
            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            return [];
        }
        
        

    }
}